import { GET_ALL_SMS , DELETE_SMS } from "../Type";
const initial = {
    Sms: [],
    DeletedSms:[],
    loading: true,
}

const SmsReducer = (state = initial, action) => {
    switch (action.type) {
        case GET_ALL_SMS:
            return {
                ...state,
                Sms: action.payload,
                loading: false
            }
        case DELETE_SMS:
            return {
                ...state,
                DeletedSms: action.payload,
                loading: false
            }
        default:
            return state;
    }
}

export default SmsReducer